module.exports = __webpack_public_path__ + "static/media/model5-video4.e74a5727.mp4";